import React from 'react'
import styles from './index.module.scss'

export default function Choice(props) {
  const { children, placeholder = '请选择', onClick } = props

  const handleClick = () => {
    onClick && onClick()
  }

  return (
    <div className={styles.choice} onClick={handleClick}>
      {children ? (
        <div className={styles.content}>{children}</div>
      ) : (
        <div className={styles.placeholder}>{placeholder}</div>
      )}
      <div className={styles.arrow}></div>
    </div>
  )
}
